export default __webpack_public_path__ + "static/media/image.technobrain-international-pvt-ltd.0c53e2a3.png";